var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMaida(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m49 29a14 14 0 1 1 14-14 14.017 14.017 0 0 1 -14 14z",
    fill: "#ef5072"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m51 3a13.992 13.992 0 0 0 -10.844 22.844 13.992 13.992 0 0 0 19.688-19.688 13.928 13.928 0 0 0 -8.844-3.156z",
    fill: "#fa647d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m49 29.75a14.75 14.75 0 1 1 14.75-14.75 14.767 14.767 0 0 1 -14.75 14.75zm0-28a13.25 13.25 0 1 0 13.25 13.25 13.265 13.265 0 0 0 -13.25-13.25z",
    fill: "#e4ecfb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m53.243 7.929-4.243 4.243-4.243-4.243a2 2 0 0 0 -2.828 0 2 2 0 0 0 0 2.828l4.243 4.243-4.243 4.243a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l4.243-4.243 4.243 4.243a2 2 0 0 0 2.828 0 2 2 0 0 0 0-2.828l-4.243-4.243 4.243-4.243a2 2 0 0 0 0-2.828 2 2 0 0 0 -2.828 0z",
    fill: "#f5faff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m29 24 .988-1.975a1.5 1.5 0 0 0 -2.013-2.013l-1.975.988a26 26 0 0 0 -20 0l-1.975-.988a1.5 1.5 0 0 0 -2.013 2.013l.988 1.975a73.241 73.241 0 0 0 0 34l-.988 1.975a1.5 1.5 0 0 0 2.013 2.013l1.975-.988a26 26 0 0 0 20 0l1.975.988a1.5 1.5 0 0 0 2.013-2.013l-.988-1.975a73.241 73.241 0 0 0 0-34z",
    fill: "#c39d84"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m29 24 .988-1.975.012-.025-.024.011-1.976.989a26 26 0 0 0 -20 0l-1.975-.988a1.5 1.5 0 0 0 -2.013 2.013l.988 1.975a64.992 64.992 0 0 0 0 32l-.988 1.975a1.481 1.481 0 0 0 .388 1.825l1.6-.8a26 26 0 0 0 20 0l1.975.988a1.5 1.5 0 0 0 2.013-2.013l-.988-1.975a73.241 73.241 0 0 0 0-34z",
    fill: "#b4876b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffdc73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 54.75a.75.75 0 0 1 -.75-.75v-19.25a.75.75 0 0 1 1.5 0v19.25a.75.75 0 0 1 -.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 29.243a0 0 0 0 1 0 0 6 6 0 0 1 -6 6 0 0 0 0 1 0 0 6 6 0 0 1 6-6z",
    transform: "matrix(.707 -.707 .707 .707 -18.113 20.757)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 37a0 0 0 0 1 0 0 6 6 0 0 1 -6 6 0 0 0 0 1 0 0 6 6 0 0 1 6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 37a6 6 0 0 1 6 6 0 0 0 0 1 0 0 6 6 0 0 1 -6-6 0 0 0 0 1 0 0z",
    transform: "matrix(-1 0 0 -1 26 80)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 45a0 0 0 0 1 0 0 6 6 0 0 1 -6 6 0 0 0 0 1 0 0 6 6 0 0 1 6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 45a6 6 0 0 1 6 6 0 0 0 0 1 0 0 6 6 0 0 1 -6-6 0 0 0 0 1 0 0z",
    transform: "matrix(-1 0 0 -1 26 96)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m31.879 49.121-5.879 5.879h16l-5.879-5.879a3 3 0 0 0 -4.242 0z",
    fill: "#e4ecfb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m25 55h18a0 0 0 0 1 0 0v4a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4-4v-4a0 0 0 0 1 0 0z",
    fill: "#a0ff96"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m27 57h16a0 0 0 0 1 0 0v2a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4-4v-2a0 0 0 0 1 0 0z",
    fill: "#8cf082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMaida);
export default __webpack_public_path__ + "static/media/no-maida.3d95c8b35cf48cb3b45b1577bcc487f8.svg";
export { ForwardRef as ReactComponent };